/**
 * /go/ call-to-action links (server/go.js), built the same way for the email
 * composer and Conversations.
 */
export const CTA_ACTIONS = ['subscribe', 'join', 'rsvp', 'support', 'signup'];

// Which kind of listing each action points at.
export const CTA_LISTING_KIND = {
  subscribe: 'pages',
  support: 'pages',
  join: 'liveRooms',
  rsvp: 'liveRooms',
  signup: null,
};

// Every audience-facing call-to-action is this orange (Yuko, 28 Sep 2026).
export const CTA_COLOR = '#FD3800';

const rootUrl = () =>
  (typeof window !== 'undefined' && window.location?.origin) || process.env.REACT_APP_CANONICAL_ROOT_URL || '';

/**
 * @param {Object} cta     { action, listingId, episodeId }
 * @param {Object} source  { src: 'email' | 'chat', m: campaign or card id }
 */
export const buildGoUrl = ({ action, listingId, episodeId }, { src, m } = {}) => {
  const path =
    action === 'signup'
      ? '/go/signup'
      : action === 'rsvp'
      ? `/go/rsvp/${listingId}/${episodeId}`
      : `/go/${action}/${listingId}`;
  const params = new URLSearchParams();
  if (src) params.set('src', src);
  if (m) params.set('m', m);
  const qs = params.toString();
  return `${rootUrl()}${path}${qs ? `?${qs}` : ''}`;
};

// A short random id for a chat card, so its clicks can be counted (m=).
export const newCardId = () =>
  `c${Date.now().toString(36)}${Math.random()
    .toString(36)
    .slice(2, 8)}`;
